const SvgBtn = ({ icon, onClick, variant = "", color = "" }) => {
  return (
    <>
      <button
        type="button"
        className={`btn-icon`}
        onClick={onClick}
        data-variant={variant}
        data-color={color}
      >
        <img src={icon} alt="Info Icon" />
      </button>
    </>
  );
};

export default SvgBtn;
